export type Resolved<Result> = [Result, null]
export type Rejected = [null, NonNullable<unknown>]
export type AsyncResult<Result> = Resolved<Result> | Rejected

export async function asyncResult<Result>(promise: Promise<Result>): Promise<AsyncResult<Result>>
export async function asyncResult<Result>(fn: () => Promise<Result>): Promise<AsyncResult<Result>>
export async function asyncResult<Result>(promiseOrFn: Promise<Result> | (() => Promise<Result>)): Promise<AsyncResult<Result>> {
    try {
        let result: Result;
        if (typeof promiseOrFn === 'function') {
            result = await promiseOrFn();
        } else {
            result = await promiseOrFn;
        }
        return [result, null];
    } catch (error: unknown) {
        if (!error) {
            return [null, new Error('Unknown error')];
        }
        return [null, error];
    }
}
